import React from 'react';
import { render } from 'react-dom';
// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';

// After a redeploy the hashed chunk filenames change; a tab still running the OLD
// index will fail to lazy-load its (now-removed) chunks and Vite fires
// `vite:preloadError`. Auto-reload to pick up the fresh index — throttled to once
// per 10s so a genuinely-missing chunk can't loop the page.
window.addEventListener('vite:preloadError', () => {
    const KEY = 'chunkReloadAt';
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last > 10000) {
        sessionStorage.setItem(KEY, String(Date.now()));
        window.location.reload();
    }
});

// ==============================|| REACT DOM RENDER  ||============================== //

render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
